import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Save } from 'lucide-react';
import { typesIntervention as typesData } from '../../data/mockData';

function FormulaireTypeIntervention({ user }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditing = !!id;

  const [formData, setFormData] = useState({
    code: '',
    libelle: '',
    description: '',
    dureeEstimee: 60,
    couleur: '#3b82f6',
    actif: true,
  });

  useEffect(() => {
    if (isEditing) {
      const type = typesData.find(t => t.id === parseInt(id));
      if (type) {
        setFormData({
          code: type.code,
          libelle: type.libelle,
          description: type.description,
          dureeEstimee: type.dureeEstimee,
          couleur: type.couleur,
          actif: type.actif,
        });
      }
    }
  }, [id, isEditing]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (name === 'dureeEstimee' ? parseInt(value) : value)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Type intervention sauvegardé:', formData);
    navigate('/types-intervention');
  };

  const couleursPredefinies = [
    { nom: 'Bleu', valeur: '#3b82f6' },
    { nom: 'Vert', valeur: '#10b981' },
    { nom: 'Orange', valeur: '#f59e0b' },
    { nom: 'Rouge', valeur: '#ef4444' },
    { nom: 'Violet', valeur: '#8b5cf6' },
    { nom: 'Rose', valeur: '#ec4899' },
    { nom: 'Jaune', valeur: '#eab308' },
    { nom: 'Cyan', valeur: '#06b6d4' },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <button onClick={() => navigate('/types-intervention')} className="btn-back">
            <ArrowLeft size={20} />
            Retour
          </button>
          <h1>{isEditing ? 'Modifier le type d\'intervention' : 'Nouveau type d\'intervention'}</h1>
        </div>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit} className="form-card">
          <div className="form-section">
            <h2>Informations du type</h2>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="code">Code *</label>
                <input
                  type="text"
                  id="code"
                  name="code"
                  value={formData.code}
                  onChange={handleChange}
                  placeholder="Ex: VN, VO, VC"
                  required
                  maxLength={20}
                />
                <small>Code court pour identifier le type</small>
              </div>

              <div className="form-group">
                <label htmlFor="dureeEstimee">Durée estimée (minutes) *</label>
                <input
                  type="number"
                  id="dureeEstimee"
                  name="dureeEstimee"
                  value={formData.dureeEstimee}
                  onChange={handleChange}
                  min="1"
                  step="1"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="libelle">Libellé *</label>
              <input
                type="text"
                id="libelle"
                name="libelle"
                value={formData.libelle}
                onChange={handleChange}
                placeholder="Ex: Véhicule Neuf"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows="3"
                placeholder="Description détaillée du type d'intervention"
              />
            </div>
          </div>

          <div className="form-section">
            <h2>Couleur d'affichage</h2>
            <p className="text-muted">Cette couleur sera utilisée dans les agendas et plannings</p>
            
            <div className="couleurs-grid">
              {couleursPredefinies.map((couleur) => (
                <button
                  key={couleur.valeur}
                  type="button"
                  className={`couleur-btn ${formData.couleur === couleur.valeur ? 'selected' : ''}`}
                  style={{ backgroundColor: couleur.valeur }}
                  onClick={() => setFormData(prev => ({ ...prev, couleur: couleur.valeur }))}
                  title={couleur.nom}
                >
                  {formData.couleur === couleur.valeur && '✓'}
                </button>
              ))}
            </div>

            <div className="form-group">
              <label htmlFor="couleur">Ou choisissez une couleur personnalisée</label>
              <input
                type="color"
                id="couleur"
                name="couleur"
                value={formData.couleur}
                onChange={handleChange}
                className="color-input"
              />
            </div>

            <div className="preview-type">
              <p className="text-muted">Aperçu :</p>
              <span 
                className="type-badge type-badge-lg" 
                style={{ backgroundColor: formData.couleur }}
              >
                {formData.code || 'CODE'}
              </span>
            </div>
          </div>

          <div className="form-section">
            <div className="form-group-checkbox">
              <input
                type="checkbox"
                id="actif"
                name="actif"
                checked={formData.actif}
                onChange={handleChange}
              />
              <label htmlFor="actif">Type actif</label>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={() => navigate('/types-intervention')} className="btn btn-secondary">
              Annuler
            </button>
            <button type="submit" className="btn btn-primary">
              <Save size={20} />
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FormulaireTypeIntervention;

